module.exports = __webpack_public_path__ + "img/back-img.053e29d6.svg";